import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import {
    ENVIRONMENT_INITIALIZER,
    EnvironmentProviders,
    inject,
    makeEnvironmentProviders,
    PLATFORM_ID,
} from '@angular/core';
import { Router, Scroll } from '@angular/router';
import { filter, skip } from 'rxjs';

/**
 * Igual que scrollPositionRestoration: 'enabled' (arriba al cambiar de página, posición
 * guardada al volver atrás) pero sin la navegación inicial: con SSR la página ya se ve antes
 * de que Angular arranque y el usuario puede haber bajado; si no, el router lo sube arriba
 * del todo al terminar esa primera navegación.
 * Requiere withInMemoryScrolling({ scrollPositionRestoration: 'disabled' }) para recibir
 * los eventos Scroll sin que el router haga scroll por su cuenta.
 */
export function provideScrollRestorationAfterFirstPage(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: ENVIRONMENT_INITIALIZER,
            multi: true,
            useValue: () => {
                if (!isPlatformBrowser(inject(PLATFORM_ID))) return;
                const viewportScroller = inject(ViewportScroller);
                inject(Router)
                    .events.pipe(
                        filter((event): event is Scroll => event instanceof Scroll),
                        skip(1)
                    )
                    .subscribe((event) => {
                        viewportScroller.scrollToPosition(event.position ?? [0, 0]);
                    });
            },
        },
    ]);
}
